var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('JStreamPlayer',{ref:"jStream",staticClass:"player",attrs:{"video-id":_vm.videoContentId}})}
var staticRenderFns = []

export { render, staticRenderFns }